import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Eye } from 'lucide-react'
import { Button } from '@/ui/components/common/Button'
import { resolveLanguage } from '@/application/i18n/language'
import { investigationSlug } from '@/application/seo/investigation-url'
import type { Investigation } from '@/domains/types'

/**
 * Opens the public article view of an investigation in a new tab, whatever its
 * status (pending included). The compiled read view includes unpublished
 * content for privileged viewers, so this doubles as a proof-reading preview.
 * With `leadId`, the article scrolls to that lead's section.
 */
export function PreviewArticleButton({
  investigation,
  leadId,
}: {
  investigation: Pick<Investigation, 'id' | 'slugs' | 'sourceLocale'>
  leadId?: string
}) {
  const { t, i18n } = useTranslation()
  const locale = resolveLanguage(i18n.language)

  return (
    <Link
      to="/investigations/$slug"
      params={{ slug: investigationSlug(investigation, locale) }}
      hash={leadId ? `read-lead-${leadId}` : undefined}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button variant="outline" size="sm" leftIcon={<Eye className="w-4 h-4" />}>
        {t('admin.preview_article')}
      </Button>
    </Link>
  )
}
